import { styled } from '../../../../../modules';

export const Wrapper = styled.div<{ $labelColor: string }>`
    .form-control > div:first-child {
        color: ${({ $labelColor }) => $labelColor} !important;
        font-weight: 700 !important;
    }
`;
